// extracted by mini-css-extract-plugin
export default {"cls1":"VeloForm-Form_cls1__8omBP","cls2":"VeloForm-Form_cls2__hn8i4 VeloForm-Form_cls1__8omBP","disableHelperTextPadding":"VeloForm-Form_disableHelperTextPadding__zCdVE"};